import React from 'react';
import type { MetricTableRow } from '@app-types/comparisonMetric';
import './MetricComparisonTable.less';

export interface MetricComparisonTableProps {
  /** API-derived right-column header, e.g. `売上高(百万円)` or `当期利益(百万ドル)`. */
  valueHeader: string;
  rows: MetricTableRow[];
  nodeId?: string;
}

const YEAR_HEADER = '年度';

/**
 * 2-column semantic table used on the right side of MetricComparisonCard.
 * Header row + 5 data rows (fiscal year → metric value).
 * See kiro_sales_revenue_task.md §8, Figma nodes 3226:26044 etc.
 */
const MetricComparisonTable: React.FC<MetricComparisonTableProps> = ({
  valueHeader,
  rows,
  nodeId,
}) => (
  <table className="comparison-metric-table" data-node-id={nodeId}>
    <caption className="comparison-metric-table__caption">
      {`${YEAR_HEADER} / ${valueHeader}`}
    </caption>
    <thead>
      <tr>
        <th
          scope="col"
          className="comparison-metric-table__cell comparison-metric-table__cell--header comparison-metric-table__cell--left"
        >
          {YEAR_HEADER}
        </th>
        <th
          scope="col"
          className="comparison-metric-table__cell comparison-metric-table__cell--header comparison-metric-table__cell--right"
        >
          {valueHeader}
        </th>
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <tr key={row.fiscalYear}>
          <th
            scope="row"
            className="comparison-metric-table__cell comparison-metric-table__cell--header comparison-metric-table__cell--left"
          >
            {row.fiscalYear}
          </th>
          <td className="comparison-metric-table__cell comparison-metric-table__cell--data comparison-metric-table__cell--right">
            {row.value}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default MetricComparisonTable;
